import { Box } from "@chakra-ui/react";
import { LabelGroup } from "pages/RefProductInter/LabelGroup";
import React from "react";
import { ButtonStyled } from "styled/Buttons.styled";

const FormShipping = ({ onCloseSpreadsheet }) => {
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between"
          // alignItems: "center",
        }}
      >
        <LabelGroup
          tipo={"date"}
          name={"name_permissionGroup"}
          // onChange={handleInputChange}
          // value={name_permissionGroup}
          tag={"Fecha disposición de carga"}
          size={45}
          desicion={false}
        />
        <LabelGroup
          tipo={"time"}
          name={"descriptions_permissionGroup"}
          // onChange={handleInputChange}
          // value={descriptions_permissionGroup}
          tag={"Hora de disposición carga"}
          size={45}
          desicion={false}
        />
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          // alignItems: "center",
          marginTop: "10px"
        }}
      >
        <LabelGroup
          name={"name_permissionGroup"}
          // onChange={handleInputChange}
          // value={name_permissionGroup}
          tag={"Modo de transporte"}
          size={45}
          desicion={false}
        />
        <LabelGroup
          name={"descriptions_permissionGroup"}
          // onChange={handleInputChange}
          // value={descriptions_permissionGroup}
          tag={"Numero de documento de transporte"}
          size={45}
          desicion={false}
        />
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          // alignItems: "center",
          marginTop: "10px"
        }}
      >
        <LabelGroup
          name={"name_permissionGroup"}
          // onChange={(e) => OnlyNumberInput(e, setValues, values)}
          // value={name_permissionGroup}
          tag={"Peso kilogramos"}
          size={45}
          desicion={false}
        />
        <LabelGroup
          name={"descriptions_permissionGroup"}
          // onChange={(e) => OnlyNumberInput(e, setValues, values)}
          // value={descriptions_permissionGroup}
          tag={"Cantidad de Bultos"}
          size={45}
          desicion={false}
        />
      </div>

      <div
        style={{
          display: "flex",
          marginTop: "10px"
        }}
      >
        <LabelGroup
          name={"name_permissionGroup"}
          // onChange={handleInputChange}
          // value={name_permissionGroup}
          tag={"Observaciones"}
          size={200}
          desicion={false}
        />
      </div>

      <Box
        display="flex"
        alignItems="center"
        marginTop={"20px"}
        marginBottom={"20px"}
        justifyContent="space-between"
        flexWrap={"wrap"}
      >
        <ButtonStyled bgColor={"#bababa"} onClick={onCloseSpreadsheet}>
          Cancelar
        </ButtonStyled>
        <ButtonStyled type="submit">Enviar</ButtonStyled>
      </Box>
    </>
  );
};

export default FormShipping;
